export const normalizeString = (value: string): string => value.trim().toLowerCase();
